import axios from "axios";
import Cookies from "js-cookie";
export const checkToken = async () => {
    const tokenData = JSON.parse(window.atob(localStorage.getItem("token").split(".")[1]));
    console.log("check6", tokenData.user_id);

    if (!tokenData.user_id) {
        try {
            const response = await axios.post(
                process.env.VUE_APP_URL + "regenerate_token",
                {},
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                },
            );
            console.log("check1", response.data);
            return response.data.token;
        } catch (error) {
            console.error("Error fetching data:", error);
            throw error;
        }
    } else if (tokenData.user_id) {
        Cookies.set("sessionToken", localStorage.getItem("token"), {
            domain: ".outpostchess.com",
            path: "/",
            secure: true,
            sameSite: "None", // Important for cross-subdomain + HTTPS
            expires: 7, // optional: expires in 7 days
        });
    }
};
